module.exports = __webpack_public_path__ + "02_medium_gold.84ca0a4f.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer5/02_medium_gold.png
// module id = CHJR
// module chunks = 0